<template>
  <div class="AfterPaymentPageView">
    <el-row :justify="'center'" :align="'middle'" type="flex">
      <el-col :sm="13">
        <MessageInfo
          :messageType="messageInfo.type"
          :title="messageInfo.title"
          :code="messageInfo.code"
          :description="messageInfo.description"
        >
          <div slot="footer">
            <GoBackToSalesServicePoint
              v-if="salesServicePointRedirectUrl" 
              :redirectUrl="salesServicePointRedirectUrl"
              :asError="hasError"
            />
          </div>
        </MessageInfo>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import store from '@/store';
import { mapActions } from 'vuex';
import MessageInfo from '@/components/Common/MessageInfo';
import GoBackToSalesServicePoint from '@/components/AfterPaymentPage/GoBackToSalesServicePoint';

export default {
  name: 'AfterPaymentPage',
  components: { MessageInfo, GoBackToSalesServicePoint },
  props: {
    salesServicePointRedirectUrl: {
      type: String,
      default: null,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    lang: {
      type: String,
      default: 'pl',
    },
  },
  store,
  created() {
    this.setLanguage(this.lang);
    this.changeLoadingState(false);
  },
  methods: {
    ...mapActions(['setLanguage', 'changeLoadingState']),
  },
  computed: {
    messageInfo() {
      const messageInfoMap = {
        error: {
          type: 'error',
          title: this.$t('after_payment.error.title'),
          code: this.$t('after_payment.error.code'),
          description: this.$t('after_payment.error.description'),
        },
        success: {
          type: 'success',
          title: this.$t('after_payment.success.title'),
          code: this.$t('after_payment.success.code'),
          description: this.$t('after_payment.success.description'),
        },
      };
      return messageInfoMap[this.hasError ? 'error' : 'success'];
    },
  },
};
</script>

<style lang="sass" scoped>
.AfterPaymentPageView
  margin-top: 49px
  &__message-box
    color: #FFFFFF
    @include breakpoint(xsmall)
      text-align: center
    .message-box__success-message
      .success-message__title
        font-size: 42px
        margin: 2px
        @include breakpoint(small)
          font-size: 26px
      .success-message__description
        margin: 4px
        font-weight: 200
        @include breakpoint(small)
          font-size: 16px
    .message-box__error-message
      .error-message__title
        font-size: 20px
        text-align: center
        margin: 2px
        text-shadow: 1px 1px 2px grey
      .error-message__description
        font-size: 150px
        font-weight: 900
        text-align: center
        margin: 0px
        text-shadow: 1px 1px 2px grey
        
</style>




// WEBPACK FOOTER //
// src/views/AfterPaymentPage.vue